/** Which Google Maps browser key the design editor's 3D view uses (editor/Editor.tsx); pure, tested with node --test.
 *
 * A key in config.js (the GitHub variable GOOGLE_MAPS_BROWSER_KEY at build, or docker-entrypoint.sh) wins. Without
 * one the dashboard asks the API, GET /api/v1/config/maps, which serves the key the GitOps pipeline manages
 * (republic-gitops google/maps-keys.yaml), and only when a designer opens the 3D view. */
export type MapsConfig = { browser_key?: string | null };

/** Ask the API only when the 3D view is wanted and config.js has no key. */
export function shouldFetchMapsKey(configured: string, wanted: boolean): boolean {
  return wanted && !configured.trim();
}

/** The key to use: config.js's, else the API's, else "" (the 3D view then shows the design's own imagery). */
export function pickMapsKey(configured: string, fromApi: MapsConfig | null | undefined): string {
  return configured.trim() || (fromApi?.browser_key ?? "").trim();
}
